import { compose, defaultTo, prop, propOr, toString } from 'ramda';
import { createSelector } from 'reselect';

import { codelists } from 'constants/codelists';
import { EMPTY_VALUES } from 'constants/general';
import { getCodelistByName } from 'utils/codelists';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getSort = compose(prop('sort'), getRoot);
export const getQuickFilterState = compose(prop('quickFilter'), getRoot);
export const getUnlockedClientsRecords = compose(prop('clients'), getRoot);
export const getUnlockChannelDescById = createSelector(
	(state, id) => id,
	getCodelistByName(codelists.unlockChannels),
	(id, unlockChannels) => {
		const chosenUnlockChannel = unlockChannels.find((channel) => channel.id === toString(id));
		return compose(
			propOr(EMPTY_VALUES.STRING, 'shortDescription'),
			defaultTo(EMPTY_VALUES.OBJECT),
		)(chosenUnlockChannel);
	},
);
